import { render } from "./footer-nav.vue?vue&type=template&id=9751bed2&scoped=true"
import script from "./footer-nav.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-nav.vue?vue&type=script&setup=true&lang=js"

import "./footer-nav.vue?vue&type=style&index=0&id=9751bed2&lang=scss&scoped=true"
import "./footer-nav.vue?vue&type=style&index=1&id=9751bed2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9751bed2"],['__file',"src/Global/components/footer-nav.vue"]])

import QFooter from 'quasar/src/components/footer/QFooter.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QIcon,QSeparator,QBtn});
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9751bed2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9751bed2', __exports__)) {
    api.reload('9751bed2', __exports__)
  }
  
  module.hot.accept("./footer-nav.vue?vue&type=template&id=9751bed2&scoped=true", () => {
    api.rerender('9751bed2', render)
  })

}


export default __exports__